module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "documents-view"
    }
  }, [_c('document-set-header', {
    attrs: {
      "document-set": _vm.store.data.currentDocumentSet
    }
  }), _vm._v(" "), (_vm.sharingEnabled) ? _c('div', {
    staticClass: "row sharing-row"
  }, [_c('div', {
    staticClass: "col-xs-4 manage-users-controls"
  }, [_c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'DocumentsInvitations'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Users\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 document-select-controls"
  }, [(!_vm.selected) ? _c('button', {
    staticClass: "btn",
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-share"
  }), _vm._v(" Share selected")]) : _vm._e(), _vm._v(" "), (_vm.selected) ? _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'DocumentsShare'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-share"
  }), _vm._v(" Share " + _vm._s(_vm.selected) + " document"), (_vm.selected != 1) ? _c('span', [_vm._v("s")]) : _vm._e()]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sortedDocuments), function(docs, category) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-12 document-group data-item"
    }, [_c('h3', {
      staticClass: "document-group-title"
    }, [_vm._v(_vm._s(category))]), _vm._v(" "), _vm._l((docs), function(doc) {
      return _c('document-item', {
        key: doc.id,
        attrs: {
          "document": doc,
          "sharingEnabled": _vm.sharingEnabled
        },
        on: {
          "update:document": function($event) {
            doc = $event
          }
        }
      })
    })], 2)])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b6eecf58"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DocumentsView.vue
// module id = 288
// module chunks = 1